var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"box-shadow":"2px 2px 10px rgba(0, 0, 0, 0.2)","padding":"2px 4px 4px 4px","border-radius":"5px","cursor":"pointer","margin-right":"5px"},on:{"click":function($event){return _vm.click(_vm.object)}}},[_c('center',[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v(_vm._s(_vm.icon))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }